import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { featureDetailsRouteRef, rootRouteRef } from './routes';
import { ChartSummaryHttpApi, chartSummaryApiRef } from './api';

export const devServicesChartSummaryPlugin = createPlugin({
  id: 'dev-services-chart-summary',
  apis: [
    createApiFactory({
      api: chartSummaryApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        ChartSummaryHttpApi.create(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
    featureDetails: featureDetailsRouteRef,
  },
});

export const DevServicesChartSummaryPage =
  devServicesChartSummaryPlugin.provide(
    createRoutableExtension({
      name: 'DevServicesChartSummaryPage',
      component: () => import('./components/Router').then(m => m.Router),
      mountPoint: rootRouteRef,
    }),
  );
